import React from 'react'
import { Card, List, Typography, Button, Switch, Space, Tag, Tooltip } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

const { Text } = Typography

type HotelData = {
  id: string
  code: string
  name: string
  active?: boolean
}

type HotelMobileListProps = {
  hotels: HotelData[]
  total: number
  loading: boolean
  onEdit: (hotel: HotelData) => void
  onToggleEnabled: (hotel: HotelData, checked: boolean) => void
  sentinelRef: React.RefObject<HTMLDivElement>
  hasMore: boolean
  onLoadMore: () => void
}

const HotelMobileList: React.FC<HotelMobileListProps> = ({
  hotels,
  total,
  loading,
  onEdit,
  onToggleEnabled,
  sentinelRef,
  hasMore,
  onLoadMore,
}) => {
  return (
    <>
      <List
        grid={{ gutter: 16, xs: 1, sm: 1 }}
        dataSource={hotels}
        loading={loading}
        renderItem={(hotel) => {
          const code = hotel.code.toLowerCase().replace(/\s+/g, '')
          const relativeUrl = `/administrator/${code}`
          return (
            <List.Item>
              <Card style={{ width: '100%' }}>
                <Card.Meta
                  title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Link to={relativeUrl} target="_blank" rel="noopener noreferrer">
                        <Text strong underline>{hotel.name}</Text>
                      </Link>
                      <Tooltip title={hotel.active ? 'Disable' : 'Enable'}>
                        <Switch
                          checked={hotel.active}
                          onChange={(checked) => onToggleEnabled(hotel, checked)}
                          size="small"
                          style={{ width: 40 }}
                        />
                      </Tooltip>
                    </div>
                  }
                  description={
                    <Space orientation="vertical" size={4} style={{ marginTop: 4 }}>
                      <Tag color="blue">{hotel.code}</Tag>
                      <Text copyable type="secondary" style={{ fontSize: 12 }}>{hotel.id}</Text>
                    </Space>
                  }
                />
                <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
                  <Button icon={<EditOutlined />} onClick={() => onEdit(hotel)}>Edit</Button>
                </div>
              </Card>
            </List.Item>
          )
        }}
      />
      {hasMore && <div ref={sentinelRef} style={{ height: 1 }} />}
      <div style={{ textAlign: 'center', marginTop: 8 }}>
        {hasMore ? (
          <Button type="link" onClick={onLoadMore}>
            Showing {hotels.length} of {total} hotels — Load more
          </Button>
        ) : (
          <Text type="secondary">Showing {hotels.length} of {total} hotels</Text>
        )}
      </div>
    </>
  )
}

export default HotelMobileList
